/**
 * @generated SignedSource<<3b08ac4ff9b0e2ba9ae1e2cf0b54648a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedTopHeroBannerModule_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly " $fragmentType": "HpSharedTopHeroBannerModule_viewer";
};
export type HpSharedTopHeroBannerModule_viewer$key = {
  readonly " $data"?: HpSharedTopHeroBannerModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedTopHeroBannerModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedTopHeroBannerModule_viewer",
  "selections": [
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0d03498576f315827fe1f91d8ab5d0cc";

export default node;
